import React, { Fragment, useRef, useState, useEffect } from "react";
import { Popover, Transition } from "@headlessui/react";
import { useStaticQuery, graphql } from "gatsby";
import { AnchorLink } from "gatsby-plugin-anchor-links";

const MainMenu = () => {
  const data = useStaticQuery(graphql`
    {
      allMenuItems(
        filter: { menu_name: { eq: "main" }, parent: { id: { eq: null } } }
        sort: { order: DESC, fields: weight }
      ) {
        nodes {
          url
          childrenMenuItems {
            url
            childrenMenuItems {
              url
              title
            }
            title
          }
          title
        }
      }
      menuItems(menu_name: { eq: "main-navigation-button" }) {
        title
        url
      }
    }
  `);
  const menuItems = data?.allMenuItems?.nodes;
  const cta = data?.menuItems;
  return (
    <>
      {menuItems?.length ? (
        <>
          <nav className="relative flex-wrap flex-grow justify-between items-center hidden xl:flex menu print:hidden">
            <ul
              className="flex flex-wrap flex-grow justify-around py-2 text-xs max-w-5xl items-center"
              aria-hidden
            >
              {menuItems.map((c1, index) => {
                const isExternal = c1.url?.startsWith("http");
                return (
                  <>
                    {c1.childrenMenuItems?.length ? (
                      <MenuItem c1={c1} index={index} />
                    ) : (
                      <li key={"menu-" + index}>
                        <a href={c1.url} className={`menu-link`} rel="noreferrer" target={c1.target || isExternal ? "_blank" : "_self"}>
                          {c1.title ? c1.title : null}
                        </a>
                      </li>
                    )}
                  </>
                );
              })}
              <li key="menu-language-selection" className="mx-2">
                <AnchorLink className="menu-link" to="#translate">
                  <span>
                    <span className="sr-only">Language Selection</span>
                    <img
                      className="w-8 grow"
                      src="/images/united-states-flag.svg"
                      alt=""
                    />
                  </span>
                </AnchorLink>
              </li>
              {cta && (
                <li key="menu-button">
                  <a className="menu-link btn btn-red" href={cta.url}>
                    {cta.title}
                  </a>
                </li>
              )}
            </ul>
          </nav>
        </>
      ) : null}
    </>
  );
};

function MenuItem({ c1, index }) {
  let timeout; // NodeJS.Timeout
  const timeoutDuration = 10;

  const buttonRef = useRef(null); // useRef<HTMLButtonElement>(null)
  const [openState, setOpenState] = useState(false);

  const toggleMenu = (open) => {
    // log the current open state in React (toggle open state)
    setOpenState((openState) => !openState);
    // toggle the menu by clicking on buttonRef
    buttonRef?.current?.click(); // eslint-disable-line
  };

  // Open the menu after a delay of timeoutDuration
  const onHover = (open, action) => {
    // if the modal is currently closed, we need to open it
    // OR
    // if the modal is currently open, we need to close it
    if (
      (!open && !openState && action === "onMouseEnter") ||
      (open && openState && action === "onMouseLeave")
    ) {
      // clear the old timeout, if any
      clearTimeout(timeout);
      // open the modal after a timeout
      timeout = setTimeout(() => toggleMenu(open), timeoutDuration);
    }
    // else: don't click! 😁
  };

  const handleClick = (open) => {
    setOpenState(!open); // toggle open state in React state
    clearTimeout(timeout); // stop the hover timer if it's running
  };

  const handleClickOutside = (event) => {
    if (buttonRef.current && !buttonRef.current.contains(event.target)) {
      event.stopPropagation();
    }
  };
  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  });
  return (
    <Popover key={"menu-" + index}>
      {({ open }) => (
        <div
          onMouseEnter={() => onHover(open, "onMouseEnter")}
          onMouseLeave={() => onHover(open, "onMouseLeave")}
          className="relative"
        >
          <Popover.Button ref={buttonRef} className={`menu-link cursor-default focus:outline-none`}>
            <div

              onClick={() => handleClick(open)}
            >
              {c1.title ? c1.title : null}
            </div>
          </Popover.Button>

          <Transition
            show={open}
            as={Fragment}
            enter="transition ease-out duration-200"
            enterFrom="opacity-0 translate-y-1"
            enterTo="opacity-100 translate-y-0"
            leave="transition ease-in duration-150"
            leaveFrom="opacity-100 translate-y-0"
            leaveTo="opacity-0 translate-y-1"
          >
            <Popover.Panel
              static
              className="z-20 absolute overflow-visible transform w-72 -translate-x-1/2 left-1/2"
            >
              <ul className="mt-2 bg-gray-50 h-auto p-6 shadow-2xl text-sm submenu dropdown">

                {c1.childrenMenuItems.map((c2, index2) => {
                  const isExternal = c2.url?.startsWith("http");
                  return (
                    <li key={"menu-" + index + "-" + index2} className="my-2">
                      <a
                        className={`menu-link`}
                        key={c2.url}
                        href={c2.url}
                        target={c2.target}
                      >
                        {c2.title}
                      </a>
                      {c2.childrenMenuItems?.length ? (
                        <ul className="pl-4 submenu">
                          {c2.childrenMenuItems.map((c3, index3) => (
                            <li
                              key={"menu-" + index + "-" + index2 + "-" + index3}
                              className={``}
                            >
                              <a
                                className="menu-link"
                                href={c3.url}
                                target={c3.target || isExternal ? "_blank" : "_self"}
                              >
                                {c3.title}
                              </a>
                            </li>
                          ))}
                        </ul>
                      ) : null}
                    </li>
                  );
                })}
              </ul>
            </Popover.Panel>
          </Transition>
        </div>
      )}
    </Popover>
  );
}

export default MainMenu;
